module.exports = __webpack_public_path__ + "resources/img/sp_cs_m.20665780a60dc86a97fa04eab4975c11.png";